export function clearUrlQueryParam(name) {
  const url = new URL(window.location.href);
  const param = url.searchParams.get(name);

  if (param) {
    url.searchParams.delete(name);
    history.replaceState(history.state, '', url.href);
  }
};